import { EventEmitter, Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class GroupGamesService {

  highlightGameEmitter = new EventEmitter();

  constructor() { }

  hover(player1: number, player2: number) {
    this.highlightGameEmitter.emit({
      event: 'on',
      players: [player1, player2]
    });
  }

  leave(player1: number, player2: number) {
    this.highlightGameEmitter.emit({
      event: 'off',
      players: [player1, player2]
    });
  }

  updateScore(player1: number, player2: number, player1_score: number, player2_score: number) {
    this.highlightGameEmitter.emit({
      event: 'update_score',
      players: [player1, player2],
      [player1]: player1_score,
      [player2]: player2_score,
    })
  }

  updateStatus(player1: number, player2: number, status: string) {
    this.highlightGameEmitter.emit({
      event: 'update_status',
      players: [player1, player2],
      status: status,
    })
  }
}
